import { Component, OnInit, Inject, HostListener } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
})

export class ConfirmationDialogComponent implements OnInit {

  public props: {
    title: string,
    message: string,
    actionLabel: string,
    cancelLabel: string
  }

  constructor(private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data
  ) {
    this.props = data;
  }

  ngOnInit() {
  }


  @HostListener('document:keydown', ['$event']) public onKeyDown($event: KeyboardEvent) {
    if ($event.key === 'Enter') {
      this.onNoClick()
    }
  }

  public onNoClick(): void {
    this.dialogRef.close({ isConfirmed: false });
  }

  public handleSubmit(event: Event | void = null): void {
    if (event) {
      event.stopPropagation();
    }

    this.dialogRef.close({ isConfirmed: true })
  }

}
